<template>
  <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
  <footer class="py-5 footer">
    <div class="container">
      <div class="row">
        <div class="mx-auto mb-4 text-center col-lg-12">
          <span class="mb-2 text-secondary me-xl-6 me-3 mb-sm-0">
          Natruper Str. 14,
49076 Osnabrück
          </span>
          <span class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0">
          fon +49 541 6001544
          </span>
          <span class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0">
          fax +49 541 6001559
          </span>
          <span class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0">
          mail hallo@adam-ki.de
          </span>
          <a
            href="https://adam-ai.com/impressum/"
            target="_blank"
            rel="noopener"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
          Impressum
          </a>
          <a
            href="https://adam-ai.com/datenschutz/"
            target="_blank"
            rel="noopener"
            class="mb-2 text-secondary me-xl-5 me-3 mb-sm-0"
          >
          Datenschutz
          </a>
          <a
            href="https://adam-ai.com/agb/"
            target="_blank"
            rel="noopener"
            class="mb-2 text-secondary mb-sm-0"
          >
          AGB
          </a>
        </div>
      </div>
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright © {{ new Date().getFullYear() }}  by <a href="https://adam-ai.com/" class="text-secondary font-weight-bold" target="_blank" rel="noopener">ADAM GMBH</a>.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
